import React from 'react';
import { SectionCard } from '../common/SectionCard';
import { cn } from '../../utils/cn';
import type { CampaignEntry, ChannelState } from '../../types/outreach';
const stateClasses: Record<ChannelState, string> = {
  queued: 'bg-muted text-muted-foreground',
  scheduled: 'bg-uae-gold/15 text-[#8a6f11]',
  live: 'bg-uae-leaf text-white',
  delivered: 'bg-uae-green text-white'
};
const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export function CampaignCalendar({
  entries
}: {
  entries: CampaignEntry[];
}) {
  const days = Array.from({
    length: 28
  }, (_, index) => index + 1);
  return <SectionCard title="Campaign calendar" description="Distribution activity across the first four weeks of the campaign window." data-id="element-753" data-mp="30hi1jakuudjf">
      <div className="grid grid-cols-7 gap-1.5" data-id="element-754" data-mp="2vlatnc8weryu">
        {weekdays.map(day => <p key={day} className="pb-1 text-center text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground" data-id="element-755" data-mp="1p4flcgmo3pzs">
            {day}
          </p>)}
        {days.map(day => {
        const dayEntries = entries.filter(entry => entry.day === day);
        return <div key={day} className="min-h-[74px] rounded-sm border border-border bg-background p-1.5" data-id="element-756" data-mp="32lqpiop0y8r">
              <p className="font-mono text-[10px] text-muted-foreground" data-id="element-757" data-mp="80di8blfeicf">
                {String(day).padStart(2, '0')}
              </p>
              <div className="mt-1 space-y-1" data-id="element-758" data-mp="3qdthjo06g5iq">
                {dayEntries.map(entry => <p key={entry.id} className={cn('truncate rounded-sm px-1 py-0.5 text-[10px] leading-tight', stateClasses[entry.state])} title={`${entry.label} — ${entry.partner}`} data-id="element-759" data-mp="3v8h4vjjg2tvq">
                    {entry.label}
                  </p>)}
              </div>
            </div>;
      })}
      </div>
      <ul className="mt-3 flex flex-wrap gap-3" data-id="element-760" data-mp="1i197q00rtt73">
        {(Object.keys(stateClasses) as ChannelState[]).map(state => <li key={state} className="flex items-center gap-1.5 text-[11px] text-muted-foreground" data-id="element-761" data-mp="1d6v9zqymz9z9">
            <span className={cn('h-2.5 w-2.5 rounded-sm', stateClasses[state])} aria-hidden="true" data-id="element-762" data-mp="187sg92o3wq6l" />
            <span className="capitalize" data-id="element-763" data-mp="20z28avnx9r1b">{state}</span>
          </li>)}
      </ul>
    </SectionCard>;
}